import { DocLayout } from './DocLayout'

export default function TermsPage() {
  return (
    <DocLayout title="Gebruiksvoorwaarden" updated="Laatst bijgewerkt: juli 2026">
      <p>
        Deze voorwaarden gelden voor het gebruik van RUST. Door een account aan te maken ga je
        hiermee akkoord. Lees ze rustig door; ze zijn bewust kort en in gewone taal geschreven.
      </p>

      <h2>Wat RUST is</h2>
      <p>
        RUST is een hulpmiddel voor structuur en overzicht: een dagplanner, herinneringen,
        ademhalingsoefeningen, een dagboek en het vastleggen van vaste plekken en
        gezondheidsmomenten. RUST is géén medisch hulpmiddel en vervangt geen zorg, behandeling of
        advies van een arts of andere zorgverlener. Raadpleeg bij gezondheidsvragen altijd een
        professional.
      </p>

      <h2>Je account</h2>
      <ul>
        <li>Je geeft correcte gegevens op en houdt je wachtwoord geheim.</li>
        <li>Je rol (cliënt of begeleider) wordt bij registratie vastgelegd en is leidend voor wat je in de app kunt zien en doen.</li>
        <li>Je bent verantwoordelijk voor wat er via jouw account gebeurt.</li>
      </ul>

      <h2>Begeleiders en cliënten</h2>
      <ul>
        <li>Een begeleider krijgt alleen toegang tot een cliënt nadat de koppeling is geaccepteerd.</li>
        <li>Zowel cliënt als begeleider kan een koppeling beëindigen; daarna stopt de toegang.</li>
        <li>Misbruik van de begeleidersrol — bijvoorbeeld meekijken zonder legitieme begeleiding — is niet toegestaan.</li>
      </ul>

      <h2>Redelijk gebruik</h2>
      <p>
        Je gebruikt RUST alleen voor waarvoor het bedoeld is. Het is niet toegestaan de app te
        ontmantelen, andermans gegevens te benaderen, of de dienst te verstoren.
      </p>

      <h2>Beschikbaarheid en aansprakelijkheid</h2>
      <p>
        We doen ons best RUST beschikbaar en betrouwbaar te houden, maar kunnen geen
        ononderbroken beschikbaarheid garanderen. We zijn niet aansprakelijk voor schade die
        ontstaat doordat de app tijdelijk niet beschikbaar is, behalve waar de wet dat wel
        verplicht.
      </p>

      <h2>Wijzigingen en stoppen</h2>
      <p>
        We kunnen deze voorwaarden aanpassen; bij ingrijpende wijzigingen laten we dat vooraf in
        de app weten. Je kunt op elk moment stoppen: verwijder je account in de app en al je
        gegevens worden mee verwijderd.
      </p>
    </DocLayout>
  )
}
